import { useWhoami } from '@/hooks/useWhoami';

const MANAGE_INTEGRATIONS_REQUIRED_MESSAGE =
  'You need the Manage Integrations entitlement to configure authentication. Ask an administrator to update your permissions.';

const CHECKING_PERMISSIONS_MESSAGE = 'Checking authentication permissions...';

/**
 * Centralizes the entitlement gate for configuring seed authentication so the
 * modal footer and credential choice step stay in sync.
 */
export function useAuthenticationConfigurationAccess() {
  const { hasEntitlement, isLoading } = useWhoami();

  const canConfigureAuthentication =
    hasEntitlement('manage_integrations') && !isLoading;
  const authenticationDisabledTooltip = isLoading
    ? CHECKING_PERMISSIONS_MESSAGE
    : MANAGE_INTEGRATIONS_REQUIRED_MESSAGE;

  return {
    canConfigureAuthentication,
    authenticationDisabledTooltip,
  };
}
